export default () => {
  const items = [...document.querySelectorAll('.js-faq')]
  if (!items.length) return

  items.forEach(item => {
    item.addEventListener('click', () => {
      item.classList.toggle('c-faq-pane--is-open')
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/FAQ.js